import { useState } from 'react';
import { Box, Drawer, useDrawerItem } from '@ally/metronome-ui';
import { useURL } from '../../../hooks';
import styled from 'styled-components';
import { AccountListNav } from '..';
import { INavLinkDetail } from '../../../models';
import { muiAllyTheme } from '../../../utils';
import { Link } from '../../atoms';

const StyledNavLink = styled(Link)`
  display: block;
  color: ${muiAllyTheme.colors['white']};
  padding: 12px 26px;
  width: 100%;
  font-size: 1.067rem;
`;

const StyledBox = styled(Box)`
  border-bottom: 1px solid ${muiAllyTheme.colors['gray-400']};
`;

const StyledDiv = styled.div`
  background-color: #480348;
  font-size: 1.067rem;
  color: white;
  border-bottom: 1px solid ${muiAllyTheme.colors['gray-400']};
  padding: 4px 26px;
`;

const StyledLink = styled(Link)`
  height: auto;
  font-size: 1.067rem;
  line-height: 1.5;
  color: white;
`;

const StyledDrawer = styled(Drawer)`
  * {
    color: white;
    border: none;
    box-shadow: none;
  }

  > div > div > div {
    background-color: #650360;
  }

  [aria-hidden] > * {
    background-color: #480348;
    fill: white;

    > div {
      padding: 0;
    }

    > div > div > div {
      padding-top: 12px;
      padding-bottom: 12px;
      border-bottom: 1px solid ${muiAllyTheme.colors['gray-400']};
    }
  }
`;

interface IProps {
  children?: React.ReactNode;
  navLinkDetail: INavLinkDetail;
}

const SideNavLink: React.FC<IProps> = (props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { pathname } = useURL();

  const toggleItem = (e: React.MouseEvent<Element, MouseEvent>) => {
    if (props.navLinkDetail.subComponent || props.navLinkDetail.subLinks) {
      e.preventDefault();
    }
    setIsOpen(!isOpen);
  };

  return (
    <StyledBox>
      {pathname !== props.navLinkDetail.link && (
        <Box>
          {!!props.navLinkDetail.subLinks && (
            <StyledDrawer
              items={[
                {
                  heading: props.navLinkDetail.title,
                  panel: (
                    <>
                      {props.navLinkDetail.subLinks.map((item) => (
                        <StyledDiv key={item.link}>
                          <StyledLink
                            text={item.title}
                            to={item.link}
                            transmitdestination={item.transmitdestination}
                          />
                        </StyledDiv>
                      ))}
                    </>
                  ),
                },
              ]}
            />
          )}
          {!!props.navLinkDetail.subComponent && (
            <StyledDrawer
              items={[
                {
                  heading: props.navLinkDetail.title,
                  panel: <AccountListNav isSideNav={true} />,
                },
              ]}
            />
          )}
          {!!props.navLinkDetail.link && (
            <StyledNavLink
              to={props.navLinkDetail.link}
              text={props.navLinkDetail.title}
              onClick={(e: React.MouseEvent<Element, MouseEvent>) =>
                toggleItem(e)
              }
              transmitdestination={props.navLinkDetail.transmitdestination}
            />
          )}
        </Box>
      )}
    </StyledBox>
  );
};

export default SideNavLink;
